// src/services/cacheService.js
const LS_KEY = '__app_cache_v1__';
const inFlight = new Map(); // deduplicación por key (single-flight)

function loadStore() {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; }
  catch { return {}; }
}
function saveStore(store) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(store));
  } catch (e) {
    // QuotaExceededError: limpiar caché viejo y reintentar
    console.warn('⚠️ Cache storage full, clearing:', e);
    localStorage.removeItem(LS_KEY);
    try { localStorage.setItem(LS_KEY, JSON.stringify(store)); } catch { /* ignorar */ }
  }
}
function now() { return Date.now(); }

export function makeKey({ url, userId }) {
  return `examBookings:${userId}:${url}`;
}

export function getCached(key) {
  const store = loadStore();
  const entry = store[key];
  if (!entry) return null;
  return entry; // { data, etag, ts, ttl }
}

export function setCached(key, { data, etag, ttlMs }) {
  const store = loadStore();
  store[key] = { data, etag: etag || null, ts: now(), ttl: ttlMs ?? 60000 };
  saveStore(store);
}

export function isFresh(entry) {
  if (!entry) return false;
  return (now() - entry.ts) <= (entry.ttl || 0);
}

export function touch(key) {
  const store = loadStore();
  if (!store[key]) return;
  store[key].ts = now();
  saveStore(store);
}

export function invalidateByPrefix(prefix) {
  const store = loadStore();
  let changed = false;
  for (const k of Object.keys(store)) {
    if (k.startsWith(prefix)) { delete store[k]; changed = true; }
  }
  if (changed) saveStore(store);
}

export function clearAllCached() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {}
}

export async function singleFlight(key, fn) {
  if (inFlight.has(key)) return inFlight.get(key);
  const p = (async () => {
    try { return await fn(); }
    finally { inFlight.delete(key); }
  })();
  inFlight.set(key, p);
  return p;
}
